import React, { Component, Fragment } from 'react'
import { ElectivesComponent } from './index';
import { MuiGrid } from '../../../ui';
import withAppShell from '../../../hoc/withAppShell/WithAppShell';
import { connect } from 'react-redux';
import { gradePickerUtil } from '../../gradePicker';
import { SchoolInformationActions } from "../../../../store";
import lodashUtil from 'lodash';
import { toast } from 'react-toastify';
import { rulesUtil } from '../rules/dialog'
import * as StringReplacer from '../../../../i18n/StringReplacer';
import { saveSchoolConcurrently } from '../../../../utils/ConcurrentSchoolSaveUtil';

export class ElectivesContainer extends Component {
	constructor(props) {
		let gradeLevelsToBeRendered
		if (props.activeSchool.school_master !== undefined && props.activeSchool.school_master.gradeLevels.length !== 0) {
			gradeLevelsToBeRendered = { gradeLevels: [...props.activeSchool.school_master.gradeLevels] }
			gradeLevelsToBeRendered = gradePickerUtil.constructGradeLevelJSONToBeRendered(gradeLevelsToBeRendered)
		}
		super(props)
		this.state = {
			electives: undefined,
			gradeLevelsToBeRendered: gradeLevelsToBeRendered,
			isRequiredInfoAvailable: true,
			deletedElectives: [],
			schedule_constraints: [],
			updateScheduleConstraints: [],
			isSubjectChanged: false,
			constraintsArray: [
				"numberOfTeachersAndTAsForElectives",
				"fixedTeachersAndTAsForElectives",
				"multiPeriods",
				"preferredPeriods",
				"sharedRoomsForElectives",
				"totalPeriods",
				"jointClasses"
			],
			confirmationDialog: {
				isChanged: false
			},
			isSaved: false
		}
	}

	componentWillMount() {
		const i18n = this.props.i18n
		if (this.props.activeSchool.school_master === undefined) {
			toast(i18n.toastMsgs.noDataInSchoolIndormationMsg)
			this.props.previousStep()
			this.setState({
				isRequiredInfoAvailable: false
			})
		}
		else if (this.props.activeSchool.school_master.gradeLevels.length === 0) {
			toast(i18n.toastMsgs.noDataInGradeMsg)
			this.props.previousStep(false)
			this.setState({
				isRequiredInfoAvailable: false
			})
		}
		else if (this.props.activeSchool.school_master.subjects.length < 2) {
			toast(i18n.toastMsgs.noDataInSubjectMsg)
			this.props.previousStep(true)
			this.setState({
				isRequiredInfoAvailable: false
			})
		}
		else {

			if (this.props.activeSchool.school_master.electives != undefined || lodashUtil.isEmpty(this.props.activeSchool.school_master.electives)) {
				let electives = JSON.parse(JSON.stringify(this.props.activeSchool.school_master.electives));
				let schedule_constraints

				if (this.props.activeSchool.schedule_constraints !== undefined && this.props.activeSchool.schedule_constraints.length !== 0) {
					schedule_constraints = this.props.activeSchool.schedule_constraints
				}
				this.setState({
					schedule_constraints: schedule_constraints,
					electives: electives,
				});
			}
		}
	}
	editElectivesInRules = (electivesWithId, electivesArray, scheduleConstraints, name) => {
		if (scheduleConstraints !== undefined && scheduleConstraints.length != 0) {
			let constraintsArray = this.state.constraintsArray
			for (let i = 0; i < scheduleConstraints.length; i++) {
				let scheduleObj = scheduleConstraints[i]

				for (let j = 0; j < constraintsArray.length; j++) {
					let ruleName = constraintsArray[j]
					let updateSubject = scheduleObj[ruleName]

					if (updateSubject.length !== 0) {
						for (let a = 0; a < electivesArray.length; a++) {
							electivesWithId.map((electiveObj) => {
								let electiveswithSameId = updateSubject.filter(function (elective) {
									return elective.electiveId === electiveObj._id
								})

								if (electivesArray[a]._id == electiveObj._id && electivesArray[a].name !== electiveObj.name) {
									for (let i = 0; i < electiveswithSameId.length; i++) {
										let updateElectiveObj = electiveswithSameId[i]
										updateElectiveObj.electiveName = electiveObj.name
										if (scheduleObj.status === 'Completed') {
											updateElectiveObj.isDirty = true;
										}
										scheduleObj.isScheduleUpdated = true;
									}
								}
								if (electivesArray[a]._id == electiveObj._id) {
									let oldSubjects = electivesArray[a].subjects
									let changedSubjects = electiveObj.subjects
									if (oldSubjects.length === changedSubjects.length) {
										let diffSubjects = lodashUtil.differenceBy(changedSubjects, oldSubjects, "name")
										if (diffSubjects.length !== 0) {
											if (name === "isSubjectChangedInElective") {
												return true
											}
											else {
												this.deleteElectiveInRules(updateSubject, electiveObj, scheduleObj)
											}
										}
									}
									else {
										if (name === "isSubjectChangedInElective") {
											return true
										}
										else {
											this.deleteElectiveInRules(updateSubject, electiveObj, scheduleObj)
										}
									}
								}
								if (electivesArray[a]._id == electiveObj._id && electivesArray[a].name !== electiveObj.name) {
									for (let i = 0; i < electiveswithSameId.length; i++) {
										let updateElectiveObj = electiveswithSameId[i]
										updateElectiveObj.electiveName = electiveObj.name
										if (scheduleObj.status === 'Completed') {
											updateElectiveObj.isDirty = true;
										}
										scheduleObj.isScheduleUpdated = true;
									}
								}
							})
						}
					}
				}
				if (scheduleConstraints[i].isSCheduleUpdated !== undefined && scheduleConstraints[i].isSCheduleUpdated === true) {
					scheduleConstraints[i].version = scheduleConstraints[i].version + 1
				}
			}
		}
		return scheduleConstraints
	}

	deleteElectiveInRules = (updateSubject, electiveObj, scheduleObj) => {
		for (let i = 0; i < updateSubject.length; i++) {
			let updateSubjectObj = updateSubject[i]
			if (updateSubjectObj.electiveId === electiveObj._id) {
				if (scheduleObj.status !== 'Completed') {
					updateSubject.splice(i, 1)
					i -= 1
					scheduleObj.isScheduleUpdated = true;
				} else {
					updateSubject[i].isDirty = true;
					scheduleObj.isScheduleUpdated = true;
				}
			}
		}
	}
	updateDeletedElectiveInRules = (deletedElectives, scheduleConstraints) => {
		if (this.state.deletedElectives.length !== 0) {
			if (scheduleConstraints !== undefined && scheduleConstraints.length != 0) {
				let constraintsArray = this.state.constraintsArray
				for (let i = 0; i < scheduleConstraints.length; i++) {
					let scheduleObj = scheduleConstraints[i]

					for (let j = 0; j < constraintsArray.length; j++) {
						let ruleName = constraintsArray[j]
						let ruleArray = scheduleObj[ruleName]
						if (ruleArray.length > 0) {

							for (let k = 0; k < ruleArray.length; k++) {
								let elective = ruleArray[k]
								if (elective.electiveId !== undefined) {
									let subjectPresent = lodashUtil.find(deletedElectives, ["name", elective.electiveName])
									if (subjectPresent != undefined) {
										ruleArray.splice(k, 1)
										k -= 1;
										scheduleObj.isScheduleUpdated = true;
									}
								}
							}
						}
					}
					if (scheduleConstraints[i].isSCheduleUpdated !== undefined && scheduleConstraints[i].isSCheduleUpdated === true) {
						scheduleConstraints[i].version = scheduleConstraints[i].version + 1
					}
				}
			}
		}
		return scheduleConstraints;
	}

	//validation of elective name.
	onClickOfSave = async () => {
		let electives = this.state.electives
		const i18n = this.props.i18n
		let validationFlag = this.validationForElectives(electives);
		if (validationFlag === false) {

			if (this.state.schedule_constraints !== undefined && this.state.schedule_constraints.length !== 0) {

				let schedule_constraints = this.state.schedule_constraints
				let rulesAfterDeleted = await this.updateDeletedElectiveInRules(this.state.deletedElectives, schedule_constraints)
				let electivesWithId = electives.filter(function (elective) {
					return elective._id !== undefined
				})
				let electivesArray = this.props.activeSchool.school_master.electives
				schedule_constraints = await this.editElectivesInRules(electivesWithId, electivesArray, rulesAfterDeleted, "editRule")

				this.props.activeSchool.schedule_constraints = schedule_constraints

			}
			this.props.activeSchool.school_master.electives = electives;
			this.props.activeSchool.school_master.modifiedDate = new Date()
			//this.props.editSchoolInformation(this.props.userInformation._id, this.props.activeSchool._id, this.props.activeSchool)
			//toast(i18n.toastMsgs.electivesSavedSuccessfully);

			// let result = await saveSchoolConcurrently(this.props.editSchoolInformation,
			// 	this.props.userInformation._id,
			// 	this.props.activeSchool._id, 
			// 	this.props.activeSchool,
			// 	i18n.toastMsgs.electivesSavedSuccessfully);

			let result = await saveSchoolConcurrently(this.props.editSchoolInformation,
				this.props.userInformation._id,
				this.props.activeSchool._id,
				this.props.activeSchool,
				i18n.toastMsgs.electivesSavedSuccessfully);

			this.setState({
				confirmationDialog: {
					isChanged: false
				}
			})
		}

	}

	validationForElectives = (electives) => {
		const i18n = this.props.i18n
		let validationFlag = false;
		for (let i = 0; i < electives.length; i++) {
			let electiveObj = electives[i]
			// checking if the name is null or blank
			if (electiveObj.name === null || lodashUtil.isEmpty(electiveObj.name.trim())) {
				toast(i18n.electives.electiveNameIsEmpty);
				validationFlag = true;
				break;
			}
			// checking subject list is not empty
			else if (electiveObj.subjects.length === 0) {
				toast(i18n.electives.selectMin2Subejct);
				validationFlag = true;
				break;
			}
			// the last loop shouldn't go inside this loop as we are taking "i + 1" which will result in out of bounds execption
			else if (i < electives.length - 1) {
				for (let j = i + 1; j < electives.length; j++) {
					let electiveObjectToCompare = electives[j]
					// checking if there are any duplicate elective name.
					if (electiveObj.name === electiveObjectToCompare.name) {
						let errorMessage_uniqueElectiveName = StringReplacer.getFormatedMessage(i18n.electives.uniqueElectiveName,
							{
								ElectiveName: electiveObjectToCompare.name
							})
						toast(errorMessage_uniqueElectiveName)
						validationFlag = true;
						break;
					}
					//check for gradeDetails are same
					let elelctiveObjGradeDetail = gradePickerUtil.convertingGradeDetailsToLowestFormat(electiveObj.gradeDetails, this.props)
					let electiveObjectToCompareGradeDetail = gradePickerUtil.convertingGradeDetailsToLowestFormat(electiveObjectToCompare.gradeDetails, this.props)
					if (elelctiveObjGradeDetail.length <= electiveObjectToCompareGradeDetail.length) {
						let compareGradeDetails = lodashUtil.difference(elelctiveObjGradeDetail, electiveObjectToCompareGradeDetail);
						if (compareGradeDetails.length === 0) {
							validationFlag = this.subjectArrayCheck(electiveObj.subjects, electiveObjectToCompare.subjects);
							if (validationFlag === true) {
								let errorMessage_sameGradeDetailAndSubjectError = StringReplacer.getFormatedMessage(i18n.electives.sameGradeDetailAndSubjectError,
									{
										Elective1: electiveObj.name,
										Elective2: electiveObjectToCompare.name
									})
								toast(errorMessage_sameGradeDetailAndSubjectError);
							}
						}
					} else if (electiveObjectToCompareGradeDetail.length < elelctiveObjGradeDetail.length) {
						let compareGradeDetails = lodashUtil.difference(electiveObjectToCompareGradeDetail, elelctiveObjGradeDetail);
						if (compareGradeDetails.length === 0) {
							validationFlag = this.subjectArrayCheck(electiveObjectToCompare.subjects, electiveObj.subjects)
							if (validationFlag === true) {
								let sameGradeDetailAndSubjectError = StringReplacer.getFormatedMessage(i18n.electives.sameGradeDetailAndSubjectError,
									{
										Elective1: electiveObj.name,
										Elective2: electiveObjectToCompare.name
									})
								toast(sameGradeDetailAndSubjectError);
							}
						}
					}
				}
				if (validationFlag === true) {
					break
				}
			}

		}
		return validationFlag;
	}

	subjectArrayCheck = (firstSubjectList, secondSubjectList) => {
		let subjectListRepeating = true
		if (firstSubjectList.length === secondSubjectList.length) {
			let firstSubLength = firstSubjectList.length;
			let subCount = 0;
			for (let d = 0; d < firstSubjectList.length; d++) {
				let subjectName = firstSubjectList[d].name;
				let isSubjectPresent = lodashUtil.find(secondSubjectList, ["name", subjectName]);
				if (isSubjectPresent != undefined) {
					subCount++;
				}
			}
			if (subCount === firstSubLength) {
				subjectListRepeating = true;
			} else {
				subjectListRepeating = false;
			}
		}
		// if one subject length is grater than the other then no validation required just consider it is as different subject list 
		else {
			subjectListRepeating = false;
		}
		return subjectListRepeating;
	}

	showContextualHelp = (props, event) => {
		let content = props.contextualHelp["electives"];
		if (content !== undefined) {
			props.toggleDrawer("right", true, content)(event)
		}
	}

	removeElectiveFromElectives = (key) => {
		let electives = this.state.electives
		this.state.deletedElectives.push({ name: electives[key].name })
		electives.splice(key, 1)
		this.setState({ electives: electives })

	}

	deleteRulesForElectivesIfGradeChanged = (constraintsArray, elective) => {
		let scheduleConstraints = JSON.parse(JSON.stringify(this.state.schedule_constraints))
		scheduleConstraints = rulesUtil.deleteRulesIfGradedetailsChanged(scheduleConstraints, constraintsArray, elective)
		this.setState({
			schedule_constraints: scheduleConstraints
		})
	}

	componentWillUnmount = async () => {
		if (this.state.confirmationDialog.isChanged) {
			await this.beforeUnload()
		}
	}

	undoChanges = () => {
		this.setState({
			confirmationDialog: {
				isChanged: false
			}
		})
	}
	beforeUnload = async () => {
		const i18n = this.props.i18n
		var flag = window.confirm(i18n.electives.msgForUnsavedChangesInTab);
		if (flag) {
			if (!this.state.isSaved) {
				await this.onClickOfSave()
			}
		}
		else {
			await this.undoChanges()
		}
	}
	render() {

		return (<Fragment>
			<ElectivesComponent {...this.props}
				{...this.state}
				editElectivesInRules={this.editElectivesInRules}
				deleteRulesForElectivesIfGradeChanged={this.deleteRulesForElectivesIfGradeChanged}
				onClickOfSave={this.onClickOfSave}
				showContextualHelp={this.showContextualHelp}
				removeElectiveFromElectives={this.removeElectiveFromElectives}
			/>
		</Fragment>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		activeSchool: state.schoolInformation.activeSchool,
		userInformation: state.userProfile.userInformation,
		updateSchoolinformationInProgress: state.schoolInformation.updateSchoolinformationInProgress
	}
}

const mapDispatchToProps = (dispatch) => ({
	editSchoolInformation: (ownerId, schoolId, data) => dispatch(SchoolInformationActions.editSchoolInformation(ownerId, schoolId, data)),
	updatedSchoolMaster: (ownerId, schoolId, data) => dispatch(SchoolInformationActions.updatedSchoolMaster(ownerId, schoolId, data))
})

export default connect(mapStateToProps, mapDispatchToProps)(withAppShell(ElectivesContainer)) 
